export const WorkDurationOptions = [
  {
    label: '在校学生',
    value: 0
  },
  {
    label: '1年经验',
    value: 1
  },
  {
    label: '1~3年经验',
    value: 2
  },
  {
    label: '3~5年经验',
    value: 3
  },
  {
    label: '5年以上经验',
    value: 4
  }
];



// WEBPACK FOOTER //
// ./src/resources/work-durations.js